export const SECTIONS = 'SECTIONS';
